import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Buttons,
  MULTI_SELECT_CONFIG,
  TITLE,
  intialMultiSelectItems,
  multiSelectItems
} from './constants'
import { getButtonClasses, getButtonLabel } from './utils'
import DashboardNowcastingTemplate from '../components/templates/DashboardNowcastingTemplate'
import { getDashboardNowcastingData } from 'api/DashboardNowcasting'
import { useParams } from 'react-router-dom'
import Loading from '@ublique/components/Loading'

const DashboardNowcasting = () => {
  const { scenarioId } = useParams()
  const [currentBtnActiveId, setCurrentBtnActiveId] = useState('none')
  const [selectedItems, setSelectedItems] = useState(intialMultiSelectItems)
  const [data, setData] = useState()
  const { t } = useTranslation('OutputView')

  useEffect(() => {
    async function fetchData() {
      const response = await getDashboardNowcastingData({ scenarioId })
      setData(response)
    }
    fetchData()
  }, [scenarioId])

  const stripeButtons = [
    {
      id: 'pull',
      classNames: getButtonClasses({
        id: 'pull',
        selectedId: currentBtnActiveId
      }),
      label: getButtonLabel({
        id: 'pull',
        selectedId: currentBtnActiveId,
        t,
        label: Buttons.PULL
      }),
      action: ({ currentTarget }) => {
        setCurrentBtnActiveId(
          currentTarget?.id === currentBtnActiveId ? 'none' : currentTarget?.id
        )
      }
    },
    {
      id: 'push',
      classNames: getButtonClasses({
        id: 'push',
        selectedId: currentBtnActiveId
      }),
      label: getButtonLabel({
        id: 'push',
        selectedId: currentBtnActiveId,
        t,
        label: Buttons.PUSH
      }),
      action: ({ currentTarget }) => {
        setCurrentBtnActiveId(
          currentTarget?.id === currentBtnActiveId ? 'none' : currentTarget?.id
        )
      }
    },
    {
      id: 'pest',
      classNames: getButtonClasses({
        id: 'pest',
        selectedId: currentBtnActiveId
      }),
      label: getButtonLabel({
        id: 'pest',
        selectedId: currentBtnActiveId,
        t,
        label: Buttons.PUSH_ESTREMO
      }),
      action: ({ currentTarget }) => {
        setCurrentBtnActiveId(
          currentTarget?.id === currentBtnActiveId ? 'none' : currentTarget?.id
        )
      }
    }
  ]

  const configMenu = {
    initialSelectedItems: intialMultiSelectItems.map((obj) => ({
      ...obj,
      text: t(obj.text)
    })),
    titleText: t(MULTI_SELECT_CONFIG.TITLE),
    items: multiSelectItems.map((obj) => ({
      ...obj,
      text: t(obj.text)
    })),
    label: t(MULTI_SELECT_CONFIG.LABEL),
    itemToString: (item) => (item ? item.text : ''),
    onChange: ({ selectedItems }) => {
      setSelectedItems(selectedItems)
    }
  }

  if (!data) return <Loading />

  return (
    <DashboardNowcastingTemplate
      title={t(TITLE)}
      data={data}
      stripeButtons={stripeButtons}
      configMenu={configMenu}
      selectedItems={selectedItems}
      btnActiveId={currentBtnActiveId}
    />
  )
}

export default DashboardNowcasting
